/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import { SidebarGlobal } from "./_SidebarGlobal";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import AppActions from "./AppActions";
import Icon from "./Icon";
import L from "./Lang";
import { Modal } from "react-bootstrap";
import UploadPad from "./UploadPad";
import Globals from "../shared/Globals";

class ProductView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                isConservativeCare: this.props.params.tab === 'conservative-care',
                images: []
            },
            saving: false
        };
        if (this.props.params.id) {
            this.state.loading = true;
        }

        this.submit = this.submit.bind(this);

    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
        this.fillList('/api/manufacturer/list', 'manufacturers', true);
        this.fillList('/api/data/model/data/Category', 'categories');
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = () => {
        if (this.props.params.id) {
            qreq.get('/api/product/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.setState({ item: j.item, currentImage: j.item.imageIdent, currentImageF: true });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    submit(e) {
        e.preventDefault();

        var psize = this.state.item.productSize;

        if (psize) {
            psize = psize.trim().toLowerCase();
            if (psize.indexOf('x') < 0) {
                this.alert('The product size is invalid.');
                return;
            }
            try {
                var p = psize.split('x');
                var w = Number(p[0]);
                var l = Number(p[1]);

                if (w > l) {
                    this.alert('Width can not be larger than length.');
                    return;
                }
            }
            catch {
                this.alert('Failed to parse the product size.');
                return;
            }
        }

        let item = { ...this.state.item };

        if (this.state.MODEL !== 'WMS' && this.state.MODEL !== 'MNF') {
            item.productSize = '1x1';
        }

        this.setState({ item: item, saving: true });

        qreq.post('/api/product/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    showUpload = () => {
        this.setState({ showUploadModal: true });
    }

    imageUploaded = (item) => {
        let i = { ...this.state.item };
        if (!i.images) i.images = [];
        i.imageIdent = item.fileIdent;
        i.images.push({ imageIdent: item.fileIdent });

        this.setState({ item: i, imageIdent: item.fileIdent, showUploadModal: false, currentImage: item, currentImageF: null });
    }

    replaceImage = () => {
        this.setState({ imageIdent: null, currentImage: null, currentImageF: null });
    }

    deleteImage = (idx) => {
        let i = { ...this.state.item };
        i.images.splice(idx, 1);
        this.setState({ items: i });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit Product</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Edit Product {this.state.item.isConservativeCare ? <small className="d-block"><L>Conservative Care</L></small> : ''}</h1>
                <Breadcrumb path={[['Products', '/product/list' + (this.state.item.isConservativeCare ? '/conservative-care' : '')], ['Edit']]} />

                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg">
                        <Icon icon="faSave" /> <L>Save</L></button>
                </AppActions>

                <div className="row">
                    <div className="col-md-8">
                        <Card title="Info">
                            <div className="row row-cols-2">
                                <div className="col">
                                    <FormInput model={this.state.item} name="productName" label="Product Name" type="text" required />
                                </div>
                                <div className="col">
                                    <FormInput model={this.state.item} name="manufacturerID" label="Manufacturer" type="select" options={this.state.manufacturers ?? []} required />
                                </div>
                                <div className="col">
                                    <FormInput model={this.state.item} name="isPricePerUnit" label="Is Price by Unit" type="switch" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row row-cols-2">
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="catalogCode" label="Catalog Code" type="text" />
                                </div>
                                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && this.state.item.isPricePerUnit && <div className="col-md">
                                    <FormInput model={this.state.item} name="productSize" label="Product Size (LxW)" type="text" required placeholder="0x0" />
                                </div>}
                                <div className="col-md">
                                    <FormInput model={this.state.item} name="incrementBy" label="Increment By" type="number" step="1" />
                                </div>
                            </div>
                            <div>
                                <FormInput model={this.state.item} name="categoryID" label="Category" type="select" options={this.state.categories || []} />
                            </div>
                            <div>
                                <FormInput model={this.state.item} name="qCode" label="QCode (Optional)" type="text" disabled={this.state.item.qCode && this.state.item.id} />
                                {this.state.item.qCode && this.state.item.id && <div className="text-muted mb-3"><L>QCode can not be changed once set.</L></div>}
                            </div>
                            {!this.state.item.isConservativeCare ?
                                <div className="row row-cols-2">
                                    <div className="col">
                                        <FormInput model={this.state.item} name="price" label={this.state.item.isPricePerUnit ? 'Price by Unit' : 'Price for Product'} type="number" step="0.01" placeholder="0.00" />
                                    </div>
                                    <div className="col">
                                        <FormInput model={this.state.item} name="cogs" label="Cost of Goods" type="number" step="0.01" placeholder="0.00" />
                                    </div>
                                </div> : ''}
                        </Card>



                        <Card title="Information">
                            <FormInput model={this.state.item} name="specs" label="Specifications" type="textarea" />
                            <FormInput model={this.state.item} name="description" label="Description" type="textarea" />
                        </Card>

                    </div>
                    <div className="col-md-4">

                        <Card title="Image">
                            {this.state.item?.images?.map((i, idx) => <div key={idx} style={{ position: 'relative' }}>
                                <div onClick={() => this.deleteImage(idx)} className="btn btn-danger" style={{ position: 'absolute', top: '0', right: '0' }}>
                                    <Icon icon="faClose" />
                                </div>
                                <img src={Globals.getStorageURL(i.imageIdent)} alt="" className="img-fluid" />
                            </div>)}
                            <button type="button" className="btn btn-primary w-100" onClick={this.showUpload}>
                                <L>Upload Image</L>
                            </button>
                        </Card>



                    </div>
                </div>


                <Card title="Alarms">
                    <div className="row">
                        <div className="col-md-3">
                            <FormInput model={this.state.item}
                                name="lowStockAlarm"
                                label="Low Stock Alarm"
                                type="switch"
                                onChange={this.change}
                            />
                        </div>
                        {this.state.item.lowStockAlarm && <>
                            <div className="col-md-3">
                                <FormInput model={this.state.item}
                                    name="lowStockAlarmThresh"
                                    label="Low Stock Alarm Threshold"
                                    type="number"
                                    step="1"
                                    onChange={this.change}
                                    placeholder="0"
                                    required
                                />
                            </div>
                            <div className="col-md-3">
                                <FormInput model={this.state.item}
                                    name="lowStockAlarmNotify"
                                    label="Email Notification"
                                    type="switch"
                                    onChange={this.change}
                                />
                            </div>
                        </>}
                    </div>
                </Card>





                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}


                {this.state.showUploadModal && <Modal show={this.state.showUploadModal} onHide={() => this.setState({ showUploadModal: false })}>
                    <Modal.Header>
                        <Modal.Title>
                            <L>Upload</L>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UploadPad onUploadEnd={this.imageUploaded} />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ showUploadModal: false })}><Icon icon="faClose" /> <L>Close</L></button>
                    </Modal.Footer>
                </Modal>}
            </form>
        </div>;
    }
}

export default withParams(ProductView);